import React from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import Wrapper from "../atoms/Wrapper";
import Tags from "./Tags";
import MediaQuery from "react-responsive";
import { useDispatch } from "react-redux";
import { update_tags } from "../../actions/tag";

const StyledImg = styled.img`
  ${(props) =>
    props.height ? (props.mobile ? props.height : `${props.height}px`) : ""}
  ${(props) =>
    props.width ? (props.mobile ? props.width : `${props.width}px`) : ""}
`;
const Description = styled(Wrapper)`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  height: ${(props) => props.height}px;
  width: ${(props) => props.width};
  color: ${(props) => props.theme.colors.black};

  @media (max-width: 450px) {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    width: 100%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
`;
const StyledA = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.black};

  @media (max-width: 450px) {
    width: 100%;
  }
`;
const Title = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

  font-size: 1.1rem;
  line-height: 2rem;
  max-height: 4rem;

  @media (max-width: 450px) {
    width: calc(
      95vw - ${(props) => (props.mobile ? "0rem" : `${props.width}px`)} - 0.7rem
    );
  }
`;

const PublishedAt = styled.span`
  color: ${(props) => props.theme.colors.black100};
  white-space: nowrap;
`;

const DescriptionMiddle = styled.div`
  display: flex;
  height: 2.1rem;
  overflow: hidden;
  width: 100%;

  @media (max-width: 450px) {
    height: 4.2rem;
  }
`;

const DescriptionContents = styled.span`
  text-overflow: ellipsis;
  font-size: 0.95rem;
  height: 2.1rem;
  color: ${(props) => props.theme.colors.black100};
`;

const Separator = styled.span`
  ::before {
    content: "•";
    margin: 0 0.5rem;
    color: ${(props) => props.theme.colors.gray};
  }
`;

const StyledWrapper = styled(Wrapper)`
  margin: 2px 0 0 0;
  width: 100%;
  justify-content: flex-start;

  @media (max-width: 450px) {
    flex-direction: column;
    margin: 12px 0 0 0;
  }
`;

const published_at2str = (published_at) => {
  if (published_at.isAfter(dayjs().subtract(1, "days"))) {
    return `${dayjs().diff(published_at, "hours")}時間前`;
  }
  if (published_at.isAfter(dayjs().subtract(1, "weeks"))) {
    return `${dayjs().diff(published_at, "days")}日前`;
  }
  if (published_at.isAfter(dayjs().subtract(1, "months"))) {
    return `${dayjs().diff(published_at, "weeks")}週間前`;
  }
  if (published_at.isAfter(dayjs().subtract(1, "years"))) {
    return `${dayjs().diff(published_at, "months")}ヶ月前`;
  }

  return `${dayjs().diff(published_at, "years")}年前`;
};

const VideoStreamItem = (props) => {
  let ratio = 3 / 4;
  let thumbnail =
    props.item &&
    props.item.thumbnails &&
    props.item.thumbnails.find((th) => th.resolution === "medium");
  if (thumbnail === undefined) {
    thumbnail =
      props.item &&
      props.item.thumbnails &&
      props.item.thumbnails.find((th) => th.resolution === "default");
  }
  if (thumbnail !== undefined) {
    ratio = thumbnail.height / thumbnail.width;
  }
  const dispatch = useDispatch();
  const handleSaveTags = (new_tags) => {
    dispatch(update_tags("videos", props.item.id, new_tags));
  };
  const published_at = dayjs.utc(props.item.published_at);
  const published_at_str = published_at2str(published_at);
  return (
    <StyledWrapper>
      <StyledA
        target="_blank"
        rel="noopener noreferrer"
        href={`https://youtube.com/watch?v=${props.item.youtube_video_id}`}
      >
        <MediaQuery maxWidth={450}>
          <StyledImg
            src={thumbnail && thumbnail.url}
            alt={props.item.title}
            width={"100%"}
            mobile
          />
        </MediaQuery>
        <MediaQuery minWidth={451} maxWidth={1000}>
          <StyledImg
            src={thumbnail && thumbnail.url}
            alt={props.item.title}
            width={200}
            height={200 * ratio}
          />
        </MediaQuery>
        <MediaQuery minWidth={1001}>
          <StyledImg
            src={thumbnail && thumbnail.url}
            alt={props.item.title}
            width={240}
            height={240 * ratio}
          />
        </MediaQuery>
      </StyledA>

      <MediaQuery maxWidth={450}>
        <Description
          height={`calc(100% * ${ratio})`}
          width={"calc(100% - 450px)"}
        >
          <Title mobile>
            <StyledA
              target="_blank"
              rel="noopener noreferrer"
              href={`https://youtube.com/watch?v=${props.item.youtube_video_id}`}
            >
              {props.item.title}
            </StyledA>
          </Title>
          <DescriptionMiddle>
            <DescriptionContents>
              <PublishedAt>{published_at_str}</PublishedAt>
              <Separator />
              {props.item.description}
            </DescriptionContents>
          </DescriptionMiddle>
          <Tags tags={props.item.tags} saveTags={handleSaveTags} w="video" />
        </Description>
      </MediaQuery>
      <MediaQuery minWidth={451} maxWidth={1000}>
        <Description height={220 * ratio} width={"calc(100% - 220px)"}>
          <Title width={220}>
            <StyledA
              target="_blank"
              rel="noopener noreferrer"
              href={`https://youtube.com/watch?v=${props.item.youtube_video_id}`}
            >
              {props.item.title}
            </StyledA>
          </Title>
          <DescriptionMiddle>
            <DescriptionContents>
              <PublishedAt>{published_at_str}</PublishedAt>
              <Separator />
              {props.item.description}
            </DescriptionContents>
          </DescriptionMiddle>
          <Tags
            tags={props.item.tags}
            style={{ margin: "1rem 0" }}
            saveTags={handleSaveTags}
            w="video"
          />
        </Description>
      </MediaQuery>
      <MediaQuery minWidth={1001}>
        <Description height={240 * ratio} width={"calc(100% - 240px)"}>
          <Title width={240}>
            <StyledA
              target="_blank"
              rel="noopener noreferrer"
              href={`https://youtube.com/watch?v=${props.item.youtube_video_id}`}
            >
              {props.item.title}
            </StyledA>
          </Title>
          <DescriptionMiddle>
            <DescriptionContents>
              <PublishedAt>{published_at_str}</PublishedAt>
              <Separator />
              {props.item.description}
            </DescriptionContents>
          </DescriptionMiddle>
          <Tags
            tags={props.item.tags}
            style={{ margin: "1rem 0" }}
            saveTags={handleSaveTags}
            w="video"
          />
        </Description>
      </MediaQuery>
    </StyledWrapper>
  );
};

export default VideoStreamItem;
